const API_URL = '/api/ventas';

// Registrar nueva venta
export const registrarVentas = async (ventaData) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(ventaData),
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Error al procesar la venta');
        
        return data;
    } catch (error) {
        console.error("Error en registrarVenta:", error);
        throw error;
    }
};

// Anular venta existente
export const anularVentas = async (ventaId) => {
    try {
        const response = await fetch(API_URL, {
            method: 'PATCH', // Usamos PATCH para actualizaciones parciales (el estado)
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ venta_id: ventaId }),
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Error al anular la venta');

        return data;
    } catch (error) {
        console.error("Error en anularVenta:", error);
        throw error;
    }
};

// Historial (opcional, si lo necesitas centralizado)
export const getHistorialVentas = async () => {
    const response = await fetch(API_URL, { method: 'GET' }); // Tendrías que programar el GET en la API
    return await response.json();
};